// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"414":"e9c2a771","942":"e9c2a771"}[chunkId] + ".chunk.css";
};